'use strict';
const angular = require('angular');
import OffersController from './offers.controller';
import routes from './offers.routes';

export default angular.module('nomasvelloDashboardApp.offers', [])
    .config(routes)
    .controller('OffersController', OffersController)
    .name;



// WEBPACK FOOTER //
// ./client/app/manager/offers/index.ts